<template lang="pug">
ib-col
    p selected country is 
        b {{ selectedCountry }}
    p selected product is 
        b {{ selectedProduct }}
    p selected new product checkbox 
        b {{ newProducts }}
    p selected exchange type 
        b {{ selectedExchange }}
    p selected exchange type 
        b {{ selectedExch }}
    p search product type 
        b {{ searchProductType }}
    p selected product type 
        b {{ selectedProductType }}
    p default region/selected region based on country of residence is 
        b {{ defaultRegion }}
    p selected region is 
        b {{ selectedRegion }}
    p page number is 
        b {{ pageNumber }}
    p totalPages is 
        b {{ totalPages }}
    p num show is 
        b  {{ numShow }}
    p types list is 
        b  {{ typesList }}
    b {{ status }}
    p api status
        b {{ apiStatus }}
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
    Name: 'States',
    data() {
        return {
            value:'',
            data: ["One","Two","Three","Four","Five","Six","Seven","Eight"],
        }
    },
    computed: {
        ...mapState(['selectedCountry', 'selectedTab', 'listedResults', 'productResults', 'products', 'typesList', 
        'selectedExchange', 'selectedProduct', 'defaultRegion', 'setSelectedResultExch' , 'searchProductType', 'selectedRegion', 'newProducts' , 'pageNumber'
        , 'numShow', 'totalPages', 'selectedProductType', 'typesList', 'selectedProductType', 'searchResults', 'status', 'selectedExchange', 'apiStatus', 'selectedExch'])
    },
}
</script>